<template>
  <div class="min-h-screen bg-gray-100">    
    <div class="min-h-screen flex items-center justify-center bg-gray-100">
      <!-- Container que cambia según el tamaño de pantalla -->
      <div class="w-full max-w-md p-6">
        <!-- Logo Horizontal de la institución (centrado y con un 50% de ancho) -->
        <div class="flex justify-start pl-11 mb-10">
          <img 
            src="/images/logo-portal.png"
            alt="Logo Portal Estudiantil" 
            class="w-4/5" />
        </div>
        
        <!-- Botón de Google -->
        <div>
          <button 
            @click="loginWithGoogle" 
            :disabled="isLoading"
            class="w-full px-4 py-2 bg-blue-500 text-white rounded-lg shadow hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <span v-if="isLoading">Iniciando sesión...</span>
            <span v-else>Acceder con correo institucional</span>
          </button>
        </div>
        
        <!-- Mensaje de error -->
        <div 
          v-if="errorMessage" 
          class="mt-4 bg-red-100 border border-red-400 text-center text-red-700 px-4 py-3 rounded-lg mb-4"
        >
          {{ errorMessage }}
        </div>
        
        <!-- Mensaje de éxito (para logout) -->
        <div 
          v-if="successMessage" 
          class="mt-4 bg-green-100 border border-green-400 text-center text-green-700 px-4 py-3 rounded-lg mb-4"
        >
          {{ successMessage }}
        </div>
      </div>
    </div>
  </div>
</template>



<script>
// Importamos solo si vamos a usar directamente la función
// import { googleOneTap } from 'google-one-tap';

export default {
  data() {
    return {
      errorMessage: '',
      successMessage: '',
      isLoading: false,
      googleConfig: {
        client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
        auto_select: false,
        cancel_on_tap_outside: true,
        prompt_parent_id: 'prompt_container',
      }
    };
  },
  mounted() {
    // Capturar parámetros de la URL
    const urlParams = new URLSearchParams(window.location.search);
    
    // Verificar si hay un error en la URL
    const errorParam = urlParams.get('error');
    if (errorParam) {
      this.errorMessage = decodeURIComponent(errorParam);
      // Limpiar la URL sin recargar la página
      this.clearUrlParams();
    }
    
    // Verificar si estamos regresando de un cierre de sesión
    const isLoggedOut = urlParams.get('logout');
    if (isLoggedOut) {
      // Limpia cualquier estado local de autenticación de Google
      this.successMessage = 'Has cerrado sesión correctamente.';
      this.clearGoogleSession();
      // Limpiar la URL sin recargar la página
      this.clearUrlParams();
    }
  },
  methods: {
    loginWithGoogle() {
      this.isLoading = true;
      this.clearError();
      this.clearSuccess();
      
      // Redirigir a la ruta del backend para iniciar sesión con Google
      window.location.href = process.env.VUE_APP_API_INTERNAL + '/auth/google';
    },
    
    clearError() {
      this.errorMessage = '';
    },
    
    clearSuccess() {
      this.successMessage = '';
    },
    
    clearUrlParams() {
      // Limpiar parámetros de la URL sin recargar la página
      const url = new URL(window.location);
      url.searchParams.delete('error');
      url.searchParams.delete('logout');
      window.history.replaceState({}, document.title, url.pathname);
    },
    
    clearGoogleSession() {
      // Borrar cualquier estado local relacionado con Google
      localStorage.removeItem('googleToken');
      
      // También puede usar google-one-tap para limpiar estado
      if (window.google && window.google.accounts) {
        window.google.accounts.id.disableAutoSelect();
      }
      
      // Esta función simulará un cierre completo de sesión
      if (document.cookie) {
        const cookies = document.cookie.split(';');
        
        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i];
          const eqPos = cookie.indexOf('=');
          const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
          document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
        }
      }
    }
  }
};
</script>